
export const isNullOrUndefined = (object: any | null | undefined) => {
  return object === null || object === undefined;
}
